import { createApp, defineAsyncComponent } from 'vue'
import PrimeVue from '@/js/services/primevue'
import i18n from '@/js/services/i18n'

export default class VueComponents {
  constructor(container = document) {
    return this.initializeComponents(container)
  }

  async initializeComponents(container) {
    const components = container.querySelectorAll('[data-vue-component]')
    const apps = []

    // Process all components asynchronously
    const componentPromises = Array.from(components).map(async (component) => {
      const vueComponent = defineAsyncComponent(
        () => import(`./vue/${component.dataset.vueComponent}.vue`),
      )

      if (vueComponent) {
        const app = createApp(vueComponent)
        PrimeVue(app)

        app.provide('dataset', component.dataset)

        // Always initialize i18n
        const localization = i18n(document.documentElement.lang || 'ro')
        app.use(localization)

        if (component.dataset.router) {
          try {
            const routerModule = await import(
              `./routers/${component.dataset.router}.js`
            )
            const createRouter = routerModule.default
            const router = createRouter(document.documentElement.lang || 'ro')

            app.use(router)
          } catch (error) {
            console.error(
              `Failed to load router: ${component.dataset.router}`,
              error,
            )
          }
        }

        app.mount(component)
        return app
      }
      return null
    })

    // Wait for all components to be initialized
    const resolvedApps = await Promise.all(componentPromises)
    apps.push(...resolvedApps.filter((app) => app !== null))

    return apps
  }
}
